// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t8-5";
export var filledCircle = "_t8-4";
export var historyEntry = "_t8-3";
export var messageSideLeft = "_t8-1";
export var messageSideRight = "_t8-2";
export var orderTrackingCarouselWrapper = "_t8-6";
export var orderTrackingInfoContainer = "_t8-0";